<!--
 * @Author: your name
 * @Date: 2019-11-17 23:32:12
 * @LastEditTime : 2019-12-26 01:42:35
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \caredily66\src\components\common\tabbar.vue
 -->
<template>
  <div>
    <authorizedPhone></authorizedPhone>
    <!-- 仅保留pointer-events物理禁用（无视觉变化），移除所有感知相关样式 -->
    <div class="footer" :style="{ pointerEvents: isTabDisabled ? 'none' : 'auto' }">
      <van-tabbar
        v-model="active"
        class="active_tab"
        active-color="#FF5F00"
        inactive-color="#999999"
        @change="handleTabChange"
    
        @touchstart.native="preventRepeatClick"
        @click.native="preventRepeatClick"
      >
        <van-tabbar-item
          v-for="(item, index) in tabbars"
          :key="item.name"
          :badge=" item.title === '我的' ? total : null"
          :dot="item.title === '购物车'? $store.state.shopCartCount?true: false:false"
        >
          <span :class="active == index ? 'active' : ''">{{ item.title}}</span>
          <template slot="icon" slot-scope="props">
            <img :src="props.active ? item.active : item.normal" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import authorizedPhone from "../../views/common/authorizedPhone.vue";
import http from "../../cmmon/js/http.js";
import https from "../../cmmon/js/https.js";

export default {
  name: "tabber",
  components: { authorizedPhone },
  data() {
    return {
      active: this.$store.state.tabbarActive,
      show: "",
      isShow: "",
      icon: {
        active: "/src/cmmon/image/tabbar/newicon/home.png",
        inactive: "/src/cmmon/image/tabbar/newicon/home_cur.png",
      },
      total: null,
      shopCartCount: 0,
      // 控制tab物理点击禁用（核心，无视觉变化）
      isTabDisabled: false,
      // 时间戳校验（双重保险，不受异步逻辑干扰）
      lastTabClickTime: 0,
      tabbars: [
        {
          name: "/index",
          title: "首页",
          normal: require("../../cmmon/image/tabbar/newicon/home.png"),
          active: require("../../cmmon/image/tabbar/newicon/home_cur.png"),
          info: "",
        },
        {
          name: "/newproduct",
          title: "下单",
          normal: require("../../cmmon/image/tabbar/newicon/place.png"),
          active: require("../../cmmon/image/tabbar/newicon/place_cur.png"),
          info: "",
        },
        {
          name: "/newshopCart",
          title: "购物车",
          normal: require("../../cmmon/image/tabbar/newicon/购物车2@2x.png"),
          active: require("../../cmmon/image/tabbar/newicon/购物车@2x.png"),
          info: this.$store.state.shopCartCount,
        },
        {
          name: "/me",
          title: "我的",
          normal: require("../../cmmon/image/tabbar/newicon/mine.png"),
          active: require("../../cmmon/image/tabbar/newicon/mine_cur.png"),
          info: null,
        },
      ],
      Promotioninfo: {},
    };
  },
  activated() {
    this.active = this.$store.state.tabbarActive;
    // 激活组件时重置禁用状态，避免keep-alive缓存残留
    this.isTabDisabled = false;
  },
  mounted() {
    this.show = sessionStorage.getItem("agentIsShow");
    this.getUndeaL();
  },
  created() {
    this.isShow = this.$store.state.isShow;
    this.getykyAllPromotionList();
  },
  computed: {
    orderCount() {
      return this.$store.state.orderCount;
    },
  },
  methods: {
    async getykyAllPromotionList() {
      let res = await https.get(`/promotion/app/activity?category_page=true`);
      if (res.data.length > 0) {
        this.Promotioninfo = res.data;
      }
    },
    // 拦截原生点击事件，冷却期内阻止冒泡/默认行为
    preventRepeatClick(e) {
      if (this.isTabDisabled) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    // 核心tab切换处理（1秒仅触发一次，无视觉变化）
    async handleTabChange(index) {
      // 1. 时间戳双重校验：1秒内重复点击直接返回
      const now = Date.now();
      if (now - this.lastTabClickTime < 1000) {
        return;
      }
      // 2. 禁用状态校验：冷却期内返回
      if (this.isTabDisabled) {
        return;
      }

      // 标记禁用+记录点击时间
      this.isTabDisabled = true;
      this.lastTabClickTime = now;

  
      try {
        let id = this.$store.state?.orderActiveId || "";
        if (index == 1) {
          await this.getykyAllPromotionList();
        }
        // 避免数组为空时map报错的边界处理
        if (this.Promotioninfo.length && !this.Promotioninfo.map(item => item._id).includes(id)) {
          id = null;
        }
        let _id = this.Promotioninfo.length ? this.Promotioninfo[0]._id : '';
        
        // 路由跳转容错：避免重复跳转报错
        if (index === 1) {
          await this.$router.push({
            path: "/newproduct",
            query: { type: 3, activity_id: id ? id : _id },
          });
        } else if (index === 2) {
          await this.$router.push({
            path: "/newshopCart",
            query: { activity_id: id ? id : _id },
          });
        } else if (index === 3) {
          await this.$router.push('/me');
        } else if (index === 0) {
          await this.$router.push('/');
        }
      } catch (e) {
        console.log("路由跳转重复:", e);
      } finally {
        // 1秒后强制解锁，无论成功/失败都不残留禁用状态
        setTimeout(() => {
          this.isTabDisabled = false;
        }, 1000);
      }
    },
    // 请求待处理数据条数
    async getUndeaL() {
      try {
        let res = await https.get("message/app/undeal");
        if (res.code == 0) {
          if (!res.data.sign_history) {
            sessionStorage.setItem("signhistory", 0);
          } else {
            sessionStorage.setItem("signhistory", res.data.sign_history);
          }
          for (var key in res.data) {
            if (key !== "特种兵发货" && key !== "sign_history" && key !== 'sign_history_partner') {
              this.total += res.data[key];
            }
          }
          this.total = this.total != 0 ? this.total : null;
        }
      } catch (e) {
        this.$toast(e.toString());
      }
    }
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 48px;
  background-color: #fff;
  display: flex;
  position: fixed;
  justify-content: space-around;
  left: 0;
  bottom: 0;
  z-index: 2;
  padding: 2px;
  /* 移除所有感知相关的过渡/样式，保持原样式 */

  .tab {
    text-align: center;
    flex: 1;
    color: #000000;

    img {
      margin: 0 auto;
      width: 26px;
      height: 26px;
    }

    p {
      font-size: 12px;
      font-weight: 500;
    }

    &.active {
      color: #FF5F00;
    }
  }

  .van-tabbar-item__icon {
    img {
      width: 26px;
      height: 26px;
    }
  }
}

/deep/.van-info {
  background-color: #FF5F00 !important;
}
/* 彻底删掉所有禁用相关的感知样式 */
</style>